"use client";

import React from "react";
import Image from "next/image";

interface ErrorDisplayProps {
  error: Error & { digest?: string };
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center p-4 bg-ng-background`}
    >
      {/* Error Icon */}
      <div className="w-24 h-24 rounded-full flex items-center justify-center">
        <Image
          src="/icons/cross.png"
          alt="Error"
          width={48}
          height={48}
          className="w-18 h-18"
        />
      </div>

      {/* Error Heading */}
      <h2 className="text-2xl font-bold mt-5 text-ng-font-1">エラー</h2>

      {/* Error Messages */}
      <p className="text-base text-ng-font-1 mt-3 text-center">
        正常に処理できませんでした。
      </p>
      <p className="text-base text-ng-font-1 mt-3 text-center">
        再度お試しください。
      </p>

      {/* Optional: Show error details if needed (can be hidden in production) */}
      {process.env.APP_ENV === "development" && error.message && (
        <p className="text-sm text-gray-500 mt-12 text-center max-w-md">
          {error.message}
        </p>
      )}
    </div>
  );
};

export default ErrorDisplay;
